<script lang="ts">
    import { page } from '$app/stores';
    import { t } from 'svelte-i18n';
    import { useLocaleContext, useShopContext } from '$lib/context';
    import UserIcon from '$lib/assets/icons/UserIcon.svelte';
    import OrdersAndPaymentIcon from '$lib/assets/icons/OrdersAndPaymentIcon.svelte';
    import PasswordIcon from '$lib/assets/icons/PasswordIcon.svelte';
    import SettingsIcon from '$lib/assets/icons/SettingsIcon.svelte';
    import SignoutIcon from '$lib/assets/icons/SignoutIcon.svelte';
    import XRectIcon from '$lib/assets/icons/XRectIcon.svelte';
    import { onMount } from 'svelte';
    import posthog from 'posthog-js';
    import { ContextApi } from '$lib/api/contextApi.js';
    import { goto } from '$app/navigation';

    const lang = useLocaleContext();
    const shopContext = useShopContext();

    export let accountMenuOpen: boolean;
    export let marginTop: number;

    $: param = $page.url.pathname.split('/')[3];

    async function logout(event: MouseEvent) {
        event.preventDefault();

        await ContextApi.logoutCustomer(shopContext, fetch);

        posthog.reset();
        window.location.reload();
    }

    let innerWidth: number;
    $: marginRight = innerWidth > 1536 ? (innerWidth - 1536) / 2 : 0;

    function closeSideBar() {
        accountMenuOpen = false;
    }

    onMount(() => {
        window.addEventListener('click', closeSideBar);

        return () => {
            window.removeEventListener('click', closeSideBar);
        };
    });
</script>

<svelte:window bind:innerWidth />

<div
    tabindex="-1"
    role="presentation"
    on:click|stopPropagation
    class="{accountMenuOpen
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 md:-translate-y-8 translate-y-8 pointer-events-none'} transition-all duration-300 md:shadow-[0_10px_40px_rgba(0,0,0,0.25)] shadow-[0_-10px_40px_rgba(0,0,0,0.25)] text-neutral-700 font-jost fixed md:top-0 md:bottom-auto bottom-0 z-40 right-0 md:w-fit w-full bg-white p-5"
    style="
            margin-top: {marginTop}px;
            margin-right: {marginRight}px;
        "
>
    <button on:click={() => (accountMenuOpen = false)} class="absolute right-6 -top-5 size-10 bg-accent md:hidden">
        <span class="text-white"><XRectIcon /></span>
    </button>

    <div class="flex flex-col gap-y-7">
        <a
            href="/{lang}/account"
            class="flex flex-row items-center gap-x-2 {!param
                ? 'text-accent'
                : 'hover:text-primary'} group transition-colors"
            on:click={() => (accountMenuOpen = false)}
        >
            <UserIcon selected={!param} selectedColor="stroke-accent" />
            <span>{$t('account.menu.personal-data')}</span>
        </a>
        <a
            href="/{lang}/account/orders"
            class="flex flex-row items-center gap-x-2 {param === 'orders'
                ? 'text-accent'
                : 'hover:text-primary'} group transition-colors"
            on:click={() => (accountMenuOpen = false)}
        >
            <OrdersAndPaymentIcon selected={param === 'orders'} selectedColor="stroke-accent" />
            <span>{$t('account.menu.orders')}</span>
        </a>

        <a
            href="/{lang}/account/password"
            class="flex flex-row items-center gap-x-2 {param === 'password'
                ? 'text-accent'
                : 'hover:text-primary'} group transition-colors"
            on:click={() => (accountMenuOpen = false)}
        >
            <PasswordIcon selected={param === 'password'} selectedColor="stroke-accent" />
            <span>{$t('account.menu.password')}</span>
        </a>
        <a
            href="/{lang}/account/settings"
            class="flex flex-row items-center gap-x-2 {param === 'settings'
                ? 'text-accent'
                : 'hover:text-primary'} group transition-colors"
            on:click={() => (accountMenuOpen = false)}
        >
            <SettingsIcon selected={param === 'settings'} selectedColor="stroke-accent" />
            <span>{$t('account.menu.settings')}</span>
        </a>
        <button class="flex flex-row items-center gap-2 hover:text-accent group transition-colors" on:click={logout}>
            <SignoutIcon selected={param === 'logout'} selectedColor="stroke-accent" />
            <span>{$t('account.menu.logout')}</span>
        </button>
    </div>
</div>
